// extracted by mini-css-extract-plugin
module.exports = {"wrapped-price-text-container":"with-course-price-store-base_wrapped-price-text-container__0Fiqu"};